import { ArrowRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-3 font-semibold uppercase tracking-[0.18em] text-xs sm:text-sm px-8 py-4 rounded-none transition-[color,background-color,border-color,box-shadow] duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rust cursor-pointer";

const variants = {
  primary: "bg-rust text-white hover:bg-rust-dark hover:shadow-[0_0_36px_rgba(255,46,77,0.45)]",
  secondary: "border border-line text-cream hover:bg-coal hover:border-stone2",
  light: "bg-cream text-ink hover:bg-sand",
};

export const SiteButton = ({
  children,
  variant = "primary",
  onClick,
  href,
  testid,
  arrow = true,
  className = "",
}) => {
  const content = (
    <>
      <span>{children}</span>
      {arrow && (
        <ArrowRight
          className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
          aria-hidden="true"
        />
      )}
    </>
  );
  if (href) {
    return (
      <a href={href} data-testid={testid} className={`${base} ${variants[variant]} ${className}`}>
        {content}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testid} className={`${base} ${variants[variant]} ${className}`}>
      {content}
    </button>
  );
};
